import { useEffect } from "react"
import { Outlet, useLocation, useNavigate } from "react-router-dom"

import { useIsLoginPage } from "@/App/Equities/shared/utils"
import { useIsDesktop } from "@/utils/useIsDesktop"

export const DesktopMobileSwitch = () => {
  const isDesktop = useIsDesktop()
  const isLoginPage = useIsLoginPage()
  const urlPath = useLocation().pathname
  const navigate = useNavigate()

  useEffect(() => {
    if (isLoginPage) {
      navigate(`/equities/${isDesktop ? "desktop" : "mobile"}/login`)
    } else if (
      !isDesktop &&
      (urlPath.includes("/equities/desktop/") || urlPath === "/")
    ) {
      navigate("/equities/mobile/")
    } else if (
      isDesktop &&
      (urlPath.includes("/equities/mobile/") || urlPath === "/")
    ) {
      navigate("/equities/desktop/")
    }
  }, [urlPath, isDesktop, isLoginPage, navigate])

  return <Outlet />
}
